module.exports = fox._r("components/liveshow/images/banned.png", __webpack_public_path__ + "_/_/_/root/components/liveshow/images/banned.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/images/banned.png
// module id = 607
// module chunks = 4